<template>
  <div id="cat" v-cloak>
    <div class="vx-card mb-4">
      <div class="vx-card__body card-body">
        <div class="flex gap-4 justify-end">
          <vs-button
            @click.prevent="downloadExcelFile"
            class="bg_m_blue"
            :disabled="excelFileLoading"
          >
            <div class="flex gap-2 items-center">
              <span>{{ $t("DownloadExcelFile") }}</span>
              <img
                v-if="excelFileLoading"
                src="@/assets/images/loading.gif"
                class="w-6 h-6"
              />
            </div>
          </vs-button>
          <div class="flex">
            <div class="w-full">
              <vs-button
                @click="showFilters = !showFilters"
                class="bg_purple float-right"
                ><div class="px-3">
                  <feather-icon
                    icon="FilterIcon"
                    svgClasses="h-4 w-4"
                    class="ico"
                  />
                  {{ $t("Filter") }}
                </div>
              </vs-button>
            </div>
          </div>
        </div>
        <div class="vx-row" v-if="showFilters">
          <div class="vx-col w-full">
            <div class="vx-row">
              <div class="vx-col lg:w-1/4 sm:w-1/2 w-full my-1 mt-1">
                <vs-input
                  class="inputx"
                  v-model="gridSearchData.SaleAgentName"
                  :label="$t('AgentName')"
                  @keyup.enter="submitFilter"
                  v-trim-space
                  placeholder="نام نماینده"
                />
              </div>
              <div class="vx-col lg:w-1/4 sm:w-1/2 w-full my-1 mt-1">
                <vs-input
                  class="inputx"
                  v-model="gridSearchData.CustomerName"
                  :label="$t('PartyName')"
                  @keyup.enter="submitFilter"
                  v-trim-space
                  placeholder="نام و نام خانوادگی / نام شرکت"
                />
              </div>

              <div class="vx-col lg:w-1/4 sm:w-1/2 w-full my-1">
                <label class="vs-select--label datepicker-lb">{{
                  $t("FromDate")
                }}</label>
                <date-picker
                  v-model="gridSearchData.fromDate"
                  type="date"
                  format="jYYYY-jMM-jDD"
                  display-format="jYYYY-jMM-jDD"
                  class="date-picker"
                  :label="$t('FromDate')"
                  :clearable="true"
                />
              </div>
              <div class="vx-col lg:w-1/4 sm:w-1/2 w-full my-1">
                <label class="vs-select--label datepicker-lb">{{
                  $t("ToDate")
                }}</label>
                <date-picker
                  v-model="gridSearchData.toDate"
                  type="date"
                  format="jYYYY-jMM-jDD"
                  display-format="jYYYY-jMM-jDD"
                  class="date-picker"
                  :label="$t('ToDate')"
                  :clearable="true"
                />
              </div>
              <div class="vx-col w-full sm:w-2/2 pt-6">
                <div>
                  <vs-button
                    type="filled"
                    class="float-right"
                    @click.prevent="submitFilter()"
                    >{{ $t("SubmitFilter") }}</vs-button
                  >
                  <vs-button
                    type="filled"
                    class="float-right mr-4"
                    id="reset-btn"
                    @click.prevent="resetForm"
                    >{{ $t("ResetFilter") }}</vs-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row pt-4">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :pageSizeManual="pageSizeManual"
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('AgentName') },
                { title: $t('PartyName'), sort: 'PartyName' },
                { title: $t('SalePersonName') },
                { title: $t('SiteOrderNumber'), sort: 'SiteOrderNumber' },
                {
                  title: $t('TotalAmountForPayment') + $t('RialsParenthesis'),
                  name: 'TotalAmount',
                  total: 'SumOfTotalAmount',
                },
                { title: $t('CreateOn'), sort: 'CreateOn' },
                { title: $t('Description') },
                { title: $t('DateSettlement') },
                { title: $t('Action') },
              ]"
            >
              <template slot-scope="{ row, pagination }">
                <td style="width: 12%">
                  {{
                    row.saleAgentInfoBasketQuery
                      ? row.saleAgentInfoBasketQuery.name
                      : "---"
                  }}
                </td>
                <td style="width: 13%">
                  {{ row.basketCustomerInfo.name }}
                </td>
                <td style="width: 12%">
                  {{
                    row.salePersonInfo.name != null
                      ? row.salePersonInfo.name
                      : "----"
                  }}
                </td>
                <td style="width: 9%">
                  {{ "APO-" + row.id }}
                </td>
                <td style="width: 17%">
                  {{ Number(row.totalAmount).toLocaleString() }}
                </td>
                <td style="width: 8%">
                  {{ row.createOn.split(" ")[0] }}<br />{{
                    row.createOn.split(" ")[1]
                  }}
                </td>

                <td style="width: 16%">
                  {{ row.description ? row.description : "---" }}
                  <br />
                  {{ row.considerations ? row.considerations : "---" }}
                </td>
                <td style="width: 8%">
                  <span v-if="row.settlementDate">
                    {{ row.settlementDate.split(" ")[0] }}<br />{{
                      row.settlementDate.split(" ")[1]
                    }}
                  </span>
                  <span v-else> --- </span>
                </td>
                <td style="width: 5%">
                  <router-link
                    :to="{
                      path:
                        '/ChannelBaskets/BasketDetails/' +
                        tabIndex +
                        '/' +
                        row.id,
                      query: {
                        numberRowsPerPage: pagination.pageSize,
                      },
                    }"
                  >
                    <vs-button
                      radius
                      color="success"
                      size="small"
                      type="gradient"
                      icon-pack="feather"
                      icon="icon-eye"
                      class="d-inline"
                    ></vs-button>
                  </router-link>
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
#reset-btn {
  margin-left: 1.5rem;
  background: #3ec9d6 !important;
}
.inputx {
  margin-top: 3px;
}
</style>
<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import { mapActions } from "vuex";
import utils from "@/assets/utils/index";
export default {
  name: "basketManagement_ChannelBaskets_Sending_Index",
  components: {
    DataGrid,
  },
  props: {
    tabIndex: { default: "" },
    numberRowsPerPage: {
      default: -1,
    },
  },
  data() {
    return {
      showFilters: false,
      pageSizeManual: 10,
      gridDataSource: { data: [] },
      gridSearchData: {
        basketFlowState: "8",
        itemCode: "",
        fromDate: "",
        toDate: "",
      },
      excelFileLoading: false,
    };
  },
  mounted() {
    this.pageSizeManual = this.numberRowsPerPage ? this.numberRowsPerPage : -1;
    this.gridDataSource = {
      type: "app",
      service: "/Sales/api/SaleAgentBasketsQuery",
    };
    this.renderGrid();
  },
  methods: {
    ...mapActions({
      exportChannelBaskets: "excel/exportChannelBaskets",
    }),
    downloadExcelFile() {
      this.excelFileLoading = true;
      var params = utils.toQueryString(this.gridSearchData);
      this.exportChannelBaskets(params)
        .then(() => {
          this.excelFileLoading = false;
        })
        .catch(() => {
          this.excelFileLoading = false;
        });
    },
    renderGrid() {
      setTimeout(() => {
        this.$refs.grid.renderGrid();
      }, 200);
    },
    submitFilter() {
      this.$refs.grid.renderGrid(1, true);
    },
    resetForm() {
      this.gridSearchData = {
        basketFlowState: "8",
        itemCode: "",
        fromDate: "",
        toDate: "",
      };
      setTimeout(() => {
        this.$refs.grid.renderGrid(1, true);
      }, 0);
    },
  },
};
</script>
